export default __webpack_public_path__ + "static/media/Pretendard-ExtraBold.subset.819ba6b8.woff";